import { action } from 'typesafe-actions'
import { UserActionTypes, User } from './types'

export const userLogin = (user: User) => action(UserActionTypes.USER_LOGIN, user)
export const userLogout = () => action(UserActionTypes.USER_LOGOUT)
export const setUserLoading = () => action(UserActionTypes.SET_USER_LOADING)
export const setUserError = (error: string) => action(UserActionTypes.SET_USER_ERROR, error)
